import { inject, Injectable, Injector } from '@angular/core';
import { ScannerHandlerBase } from './scanner-handler-base';

@Injectable({
  providedIn: 'root',
})
export class ScannerHandlerResolverService {
  private static readonly scannerHandlerMap: Map<string, typeof ScannerHandlerBase> = new Map([]);
  private readonly injector: Injector = inject(Injector);

  public static registerHandler(key: string, adapter: typeof ScannerHandlerBase): void {
    this.scannerHandlerMap.set(key, adapter);
  }

  public getHandler(key: string): ScannerHandlerBase {
    const handlerToken: typeof ScannerHandlerBase | undefined = ScannerHandlerResolverService.scannerHandlerMap.get(key);

    if (!handlerToken) {
      throw new Error(`handler with key: ${key} not found`);
    }

    return this.injector.get(handlerToken);
  }
}
